import {CallFunction} from "../../public/bundles/w3comhulk/callFunction";
import {appRequest} from "./utils_request";
import {submitPrint} from "./utils_element";

export const importListVente = () => {
    let callFunction = new CallFunction('importListVente', 'fad fa-file fa-2x');
    callFunction.showModal('Import');
    callFunction.modalBody.innerHTML = '<p>Insérez dans la zone ci-dessous le contenu du fichier .csv.</p><textarea class="form-control" id="importCsv" rows="20"></textarea>';
    callFunction.addValidateBtn(() => {
        let csv = document.getElementById('importCsv').value;
        callFunction.startLoading();
        appRequest(urls.importListVente, {csv})
            .then(response => {
                location.reload();
            })
        ;
    });
};


export const vehicleSaleAssignment = (data, callFunction) => {
    let saleIdComposed = $('#sale-select').val(),
        saleIds = saleIdComposed.split(';'),
        saleId = saleIds[0],
        rows = JSON.parse(data),
        saleHourId = saleIds[1];
    let keepOrder = $('#keep-order').prop( "checked" );

    callFunction.addMessage('Vérification des stockages de véhicule...');
    callFunction.startLoading();

    appRequest(urls.vehicleSaleAssignmentCheck, {
        'saleId': saleId,
        'vehicleIds': rows.map(obj => obj.DocEntryVH)
    })
        .then((resp) => {
            callFunction.stopLoading();
            if (resp.result === 'failed') {
                callFunction.addMessage(resp.message);
                callFunction.addReloadButton();
            } else if (resp.result === 'confirm') {
                if (resp.detail.cancel || resp.detail.move) {
                    callFunction.addTwigTemplate(urls.vehicleSaleAssignmentConfirm, resp.detail);
                    callFunction.modalFooter.innerHTML = '';
                    callFunction.addValidateBtn(() => vehicleSaleAssignmentAssign(rows, callFunction, saleId, saleHourId, keepOrder));
                } else {
                    vehicleSaleAssignmentAssign(rows, callFunction, saleId, saleHourId, keepOrder);
                }
            }
        });
};

export const vehicleSaleAssignmentFromSale = (data, callFunction) => {
    let saleIdComposed = $('#sale-select').val(),
        saleIds = saleIdComposed.split(';'),
        saleId = saleIds[0],
        rows = JSON.parse(data),
        saleHourId = saleIds[1];
    let keepOrder = $('#keep-order').prop( "checked" );

    callFunction.addMessage('Vérification des stockages de véhicule...');
    callFunction.startLoading();

    appRequest(urls.vehicleSaleAssignmentFromSaleCheck, {
        'saleId': saleId,
        'vehicleSaleIds': rows.map(obj => obj.DocEntryVente)
    })
        .then((resp) => {
            callFunction.stopLoading();
            if (resp.result === 'failed') {
                callFunction.addMessage(resp.message);
                callFunction.addReloadButton();
            } else if (resp.result === 'confirm') {
                if (resp.detail.cancel || resp.detail.move) {
                    callFunction.addTwigTemplate(urls.vehicleSaleAssignmentConfirm, resp.detail)
                    callFunction.modalFooter.innerHTML = '';
                    // callFunction.addValidateBtn(() => vehicleSaleAssignmentAssign(rows, callFunction, saleId, saleHourId));
                    callFunction.addValidateBtn(() => vehicleSaleAssignmentFromSaleAssign(rows, callFunction, saleId, saleHourId, keepOrder));
                } else {
                    vehicleSaleAssignmentFromSaleAssign(rows, callFunction, saleId, saleHourId, keepOrder);
                }
            }
        });
};

export const vehicleSaleAssignmentAssign = (rows, callFunction, saleId, saleHourId, keepOrder) => {
    let inputReason = document.getElementById('input-reason');
    let reason = '';
    if (inputReason !== null) {
        reason = inputReason.value;
    }
    callFunction.addMessage('Affectation des véhicules...');
    callFunction.startLoading();
    appRequest(urls.vehicleSaleAssignmentAssign, {
        'saleId': saleId,
        'saleHourId': saleHourId,
        'vehicleIds': rows.map(obj => obj.DocEntryVH),
        'reason': reason,
        'keepOrder': keepOrder,
    })
        .then((resp) => {
            callFunction.stopLoading();
            callFunction.addReloadButton();
            if (resp.result === 'error') {
                console.log(resp.message); //A LAISSER
                callFunction.addUnknowError();
            } else if (resp.result === 'success') {
                callFunction.addGlobalSuccess('Affectation terminée.');
                resp.log.forEach(log => callFunction.addLineResult(log, 'info'));
            } else {
                callFunction.addUnknowError();
            }
        });
};

export const vehicleSaleAssignmentFromSaleAssign = (rows, callFunction, saleId, saleHourId, keepOrder) => {
    let inputReason = document.getElementById('input-reason');
    let reason = '';
    if (inputReason !== null) {
        reason = inputReason.value;
    }
    callFunction.addMessage('Affectation des véhicules...');
    callFunction.startLoading();
    appRequest(urls.vehicleSaleAssignmentFromSaleAssign, {
        'saleId': saleId,
        'saleHourId': saleHourId,
        'vehicleSaleIds': rows.map(obj => obj.DocEntryVente),
        'reason': reason,
        'keepOrder': keepOrder,
    })
        .then((resp) => {
            callFunction.stopLoading();
            callFunction.addReloadButton();
            if (resp.result === 'error') {
                console.log(resp.message); //A LAISSER
                callFunction.addUnknowError();
            } else if (resp.result === 'success') {
                callFunction.addGlobalSuccess('Affectation terminée.');
                resp.log.forEach(log => callFunction.addLineResult(log, 'info'));
            } else {
                callFunction.addUnknowError();
            }
        });
};

export const printPoster = function (data, callFunction) {
    submitPrint(data, callFunction, urls.printPoster);
};

export const printPj = function (data, callFunction) {
    submitPrint(data, callFunction, urls.printPJ);
};




// WEBPACK FOOTER //
// ./assets/js/display_liste_vehicule_vente.js